<template>
  <div class="c-feedback">
    <p class="c-title">
      {{ title }}
    </p>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FeedbackPanel',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.c-feedback {
  background: #fff;
  padding: 48px 32px;
  & + .c-feedback {
    margin-top: 8px;
  }
  .c-title {
    color: rgba(17, 31, 44, 1);
    font-size: 34px;
    box-sizing: border-box;
    margin-bottom: 48px;
    font-weight: 500;
  }
  .c-badge {
    background: rgba(17, 31, 44, 0.08);
    border:1PX solid rgba(17, 31, 44, 0.08);;
    color: rgba(17, 31, 44, 1);
    font-size: 32px;
    border-radius: 36px;
    padding: 14px 26px;
    display: inline-block;
    font-weight: 400;
    margin: 0 22px 40px 0;
    box-sizing: border-box;
    &.is-active {
      background: #fff;
      color: rgba(0, 137, 255, 1);
      border:1PX solid rgba(0, 137, 255, 1);
    }
  }
  .c-meta {
    color: rgba(17, 31, 44, 0.4);
    font-size: 26px;
  }
  .c-input {
    color: rgba(17, 31, 44, 0.85);
    font-size: 28px;
    border: 0;
    outline: 0;
    width: 100%;
    min-height: 36px;
    &::placeholder {
      color: rgba(17, 31, 44, 0.4);
      font-size: 26px;
    }
  }
  .c-textarea-container {
    position: relative;
    height: 200px;
    box-sizing: border-box;
    padding-bottom: 36px;
  }
  .c-textarea {
    width: 100%;
    height: 100%;
  }
  .c-count {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: right;
  }
  .mt--22 {
    margin-top: -22px;
  }
  .mb-46 {
    margin-bottom: 46px;
  }
}
</style>
